export const GROUP_TYPE = 'group'
export const SUB_GROUP_TYPE = 'subGroup'
export const EVERYONE_TYPE = 'everyone'
export const ALL_GROUP_TYPE = 'allGroup'
export const SUBSCRIBERS_TYPE = 'subscribers'
export const SUBSCRIBERS_NOT_IN_GROUP_TYPE = 'subscribersNotInGroup'
export const GROUP_HEADER_TYPE = 'groupHeader'

export const EVERYONE_NAME = 'everyone'
export const EVERY_GROUP_NAME = 'allGroup'
export const WITHOUT_GROUP_NAME = 'subscribersNotInGroup'

export const NORMAL = 0
export const EVERYONE = 1
export const SUBSCRIBER_WITHOUT_GROUP = 2

export const GROUP = 'group'
export const SUB_GROUP = 'subGroup'
export const SUBSCRIBERS = 'subscribers'

export const GROUP_STATUS = 2
export const INDIVIDUAL_STATUS = 3
